import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'content-blocks'
const verb = 'get'

export default class OspreyContentBlocksMetadata extends BaseAction {
    constructor() {
        const id = '5c33cbc2-37cb-4c74-a197-700b5847b1a7'
        const path = `/${resource}/metadata`
        super(resource, verb, path, id)
        this.noCache = true
    }

    getMetadata(fields) {
        if (!fields) {
            fields = [ 'contentBlock' ]
        }

        if (Array.isArray(fields)) {
            fields = fields.join(',')
        }

        this.params = {
            fields
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/content-blocks/content-blocks-metadata.js